import React, { useEffect, useState } from "react";
import { Table, Modal, Button, Form } from "react-bootstrap";
import { Eye, Receipt } from "react-bootstrap-icons";
import api from "../api/api";
import "./AdminOrders.scss";
import { toast } from "react-toastify";

function AdminOrders() {

  const [orders, setOrders] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [search, setSearch] = useState("");
  const [statusFilter, setStatusFilter] = useState("All");

  const [currentPage, setCurrentPage] = useState(1);
  const recordsPerPage = 10;

  useEffect(() => {
    loadOrders();
  }, []);

  const loadOrders = async () => {
    try {
      const res = await api.get("/Admin");
      setOrders(res.data);
    } catch (err) {
      console.log(err);
    }
  };

  // Search Filter
  
  const filteredOrders = orders.filter((order) => {

  const fullName = `${order.firstName} ${order.lastName}`.toLowerCase();

  const customerMatch =
    fullName.includes(search.toLowerCase());

  const statusMatch =
    statusFilter === "All" || order.status === statusFilter;

  return customerMatch && statusMatch;

});

  // Pagination
  const indexOfLast = currentPage * recordsPerPage;
  const indexOfFirst = indexOfLast - recordsPerPage;
  const currentOrders = filteredOrders.slice(indexOfFirst, indexOfLast);

  const totalPages = Math.ceil(filteredOrders.length / recordsPerPage);

  // Modal Open
  const viewOrder = async (orderId) => {

  try {

    const res = await api.get(`/Orders/${orderId}`);

    setSelectedOrder(res.data);

    setShowModal(true);

  } catch (err) {
    console.log(err);
  }

};

  // Status Change
  const updateStatus = async (orderId, status) => {
  try {

    await api.put(`/Admin/update-status/${orderId}`, {
      status: status
    });

    // update UI after success
    const updatedOrders = orders.map((o) =>
      o.orderId === orderId
        ? { ...o, status: status }
        : o
    );
    toast.success("Order Status Update Successfully.");
    setOrders(updatedOrders);

  } catch (err) {
    console.log(err);
  }
};

  // Print Invoice
  const printInvoice = async (orderId) => {
  try {

    const res = await api.get(`/Orders/${orderId}`);

    setSelectedOrder(res.data);

    setTimeout(() => {
      window.print();
    }, 300);

  } catch (err) {
    console.log(err);
  }
};

 // Status Change color
const getStatusClass = (status) => {
  switch (status) {
    case "Pending":
      return "badge bg-warning";
    case "Processing":
      return "badge bg-primary";
    case "Shipped":
      return "badge bg-info";
    case "Delivered":
      return "badge bg-success";
    case "Cancelled":
      return "badge bg-danger";
    default:
      return "badge bg-secondary";
  }
};

  return (
    <div className="container-fluid mt-4">

      <h3 className="page-title mb-4">Orders Management</h3>

      {/* SEARCH */}
      <div className="d-flex justify-content-between mb-3">

  {/* Search */}
  <input
    type="text"
    className="form-control"
    placeholder="Search customer..."
    style={{ maxWidth: "250px" }}
    onChange={(e) => setSearch(e.target.value)}
  />

  {/* Status Filter */}

  <select
    className="form-select"
    style={{ maxWidth: "200px" }}
    value={statusFilter}
    onChange={(e) => setStatusFilter(e.target.value)}
  >

    <option value="All">All Orders</option>
    <option value="Pending">Pending</option>
    <option value="Confirmed">Confirmed</option>
    <option value="Processing">Processing</option>
    <option value="Shipped">Shipped</option>
    <option value="Delivered">Delivered</option>
    <option value="Cancelled">Cancelled</option>

  </select>

</div>

      {/* TABLE */}

      <div className="table-responsive">

        <Table hover bordered className="align-middle order-table">

          <thead className="table-dark">

            <tr>
              <th>Order</th>
              <th>Customer</th>
              <th>Date</th>
              <th>Amount</th>
              <th>Payment</th>
              <th>Status</th>
              <th width="220">Action</th>
            </tr>

          </thead>

          <tbody>

            {currentOrders.map((order) => (

              <tr key={order.orderId}>

                <td>#{order.orderNo}</td>

                <td>{order.firstName} {order.lastName}</td>

                <td>
                  {new Date(order.orderDate).toLocaleDateString()}
                </td>

                <td>₹{order.totalAmount}</td>

                <td>{order.paymentMethod}</td>

                {/* STATUS DROPDOWN */}

                <td>

  <span className={getStatusClass(order.status)}>
    {order.status}
  </span>

  <Form.Select
    className="mt-1"
    size="sm"
    value={order.status || "Pending"}
    onChange={(e) => updateStatus(order.orderId, e.target.value)}
  >

    <option value="Pending">Pending</option>
    <option value="Confirmed">Confirmed</option>
    <option value="Processing">Processing</option>
    <option value="Shipped">Shipped</option>
    <option value="Delivered">Delivered</option>
    <option value="Cancelled">Cancelled</option>

  </Form.Select>

</td>

                {/* ACTION BUTTONS */}

                <td>

                  <Button
                    className="btn-icon edit me-2" style={{padding : "8px 15px" , fontSize : "15px"}}
                    onClick={() => viewOrder(order.orderId)}
                  >
                    <Eye size={16} /> View
                  </Button>

                  <Button
                    className="btn-icon delete" style={{padding : "8px 15px" , fontSize : "15px"}}
                    onClick={() => printInvoice(order.orderId)}
                  >
                    <Receipt size={16} /> Invoice
                  </Button>

                </td>

              </tr>

            ))}

          </tbody>

        </Table>

      </div>

      {/* PAGINATION */}

      <div className="d-flex justify-content-center mt-3">

        {[...Array(totalPages)].map((_, i) => (

          <Button
            key={i}
            size="sm"
            variant={currentPage === i + 1 ? "dark" : "light"}
            className="me-1"
            onClick={() => setCurrentPage(i + 1)}
          >
            {i + 1}
          </Button>

        ))}

      </div>

      {/* VIEW ORDER MODAL */}

      <Modal show={showModal} onHide={() => setShowModal(false)} size="lg">

        <Modal.Header closeButton>

          <Modal.Title>
            Order Details #{selectedOrder?.orderNo}
          </Modal.Title>

        </Modal.Header>

        <Modal.Body>

  {selectedOrder && (

    <div>

      <h6 className="mb-2"><b>Customer Details</b></h6>

      <p className="mb-2"><b>Name :</b> {selectedOrder.customerName}</p>
      <p className="mb-2"><b>Mobile :</b> {selectedOrder.mobile}</p>
      <p className="mb-2"><b>Address :</b> {selectedOrder.address}</p>
      <p className="mb-2"><b>City :</b> {selectedOrder.city}</p>

      <hr className="mb-2 mt-2"/>

      <h6 className="mb-2">Order Items</h6>

      <div className="table-responsive">

        <table className="table table-bordered">

          <thead className="table-light">

            <tr>
              <th>Product</th>
              <th width="80">Qty</th>
              <th width="100">Price</th>
              <th width="100">Total</th>
              <th width="80">Size</th>
              <th width="100">Color</th>
            </tr>

          </thead>

          <tbody>

            {selectedOrder.items.map((item, index) => (

              <tr key={index}>

                <td>{item.productName}</td>

                <td>{item.qty}</td>

                <td>₹{item.price}</td>

                <td>₹{item.qty * item.price}</td>

                <td>{item.size}</td>

                <td>{item.color}</td>

              </tr>

            ))}

          </tbody>

        </table>

      </div>

      <div className="text-end mt-2">

        <h5>Total Amount : ₹{selectedOrder.totalAmount}</h5>

      </div>

    </div>

  )}

</Modal.Body>

        <Modal.Footer>

          <Button className="btntb btn-sm" variant="secondary" onClick={() => setShowModal(false)}>
            Close
          </Button>

        </Modal.Footer>

      </Modal>


<div id="invoice-print">

{selectedOrder && (

<div className="invoice-box">

<h2>Invoice</h2>

<p><b>Order No :</b> {selectedOrder.orderNo}</p>
<p><b>Date :</b> {new Date(selectedOrder.orderDate).toLocaleDateString()}</p>

<hr/>

<h4>Customer</h4>

<p>{selectedOrder.customerName}</p>
<p>{selectedOrder.mobile}</p>
<p>{selectedOrder.address}</p>
<p>{selectedOrder.city}</p>

<hr/>

<table className="table table-bordered">

<thead>
<tr>
<th>Product</th>
<th>Qty</th>
<th>Price</th>
<th>Total</th>
<th>Size</th>
<th>Color</th>
</tr>
</thead>

<tbody>

{selectedOrder.items.map((item,i)=>(
<tr key={i}>
<td>{item.productName}</td>
<td>{item.qty}</td>
<td>₹{item.price}</td>
<td>₹{item.qty * item.price}</td>
<td>{item.size}</td>
<td>{item.color}</td>
</tr>
))}

</tbody>

</table>

<div style={{textAlign:"right"}}>
<h4>Total : ₹{selectedOrder.totalAmount}</h4>
</div>

</div>

)}

</div>
     

    </div>
  );
}

export default AdminOrders;